import React from 'react';

const SvgHookieLevel: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="hookieLevel_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 6.668h6M7 10.668h10"
      />
      <g
        clipPath="url(#hookieLevel_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle
          cx={2.75}
          cy={2.75}
          r={2.75}
          transform="translate(9.25 14.375)"
        />
        <path d="M14.75 17.125l2.75 2.75-2.625 2.625-2.635-2.636M11.76 19.865L9.125 22.5 6.5 19.875l2.75-2.75" />
        <path d="M6.5 19.875H5a2 2 0 01-2-2V4.5a2 2 0 012-2h14a2 2 0 012 2v13.375a2 2 0 01-2 2h-1.5" />
      </g>
    </svg>
  );
};

export default SvgHookieLevel;
